import React, { useEffect, useState } from "react";
import "./BeginnersCoursePage.css";
import stick1 from "../../../Assets/speak.jpg";
import stick2 from "../../../Assets/naturally.jpg";
import stick3 from "../../../Assets/structure .jpg";
// import stick9 from "../../../Assets/trail.png";
import PopupForm from "../../../Form/PopupForm";

const BeginnersCoursePage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const animateOnScroll = () => {
      const elements = document.querySelectorAll(
        ".beginners-animate-on-scroll"
      );

      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (elementTop < windowHeight - 100) {
          element.classList.add("beginners-visible");
        }
      });
    };

    window.addEventListener("scroll", animateOnScroll);
    animateOnScroll(); // Initial check

    return () => window.removeEventListener("scroll", animateOnScroll);
  }, []);

  // Handle popup form opening/closing with body scroll prevention
  const handleOpenForm = () => {
    setShowForm(true);
    // Prevent body scroll when popup is open
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = getScrollbarWidth() + 'px'; // Prevent layout shift
  };

  const handleCloseForm = () => {
    setShowForm(false);
    // Restore body scroll when popup is closed
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  // Function to get scrollbar width to prevent layout shift
  const getScrollbarWidth = () => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  };

  // Cleanup effect to restore scroll on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, []);

  return (
    <div className="beginners-page">
      {/* Hero Section */}
      <section className="beginners-hero-section">
        <div
          className={`beginners-hero-content ${
            isVisible ? "beginners-visible" : ""
          }`}
        >
          <div className="beginners-decorative-circle"></div>
          <div className="beginners-decorative-circle beginners-circle-2"></div>
          <h1>
            VOICE FINDER:{" "}
            <span className="beginners-highlight">BEGINNER LEVEL</span>
          </h1>
          <h2>UNLOCK YOUR ENGLISH POTENTIAL</h2>
          <p className="beginners-tagline">
            Break the Silence. Build Confidence. Speak Boldly.
          </p>  
          {/* <img src={stick9} alt="fd" /> */}
          <div className="beginners-cta-container">
            <button onClick={handleOpenForm} className="beginners-cta-button">
            Start Your Journey
          </button>
            <div className="beginners-free-trial-badge">
              <span>FREE TRIAL</span>
              <div className="beginners-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Course Promise Section */}
      <section className="beginners-course-promise beginners-animate-on-scroll">
        <div className="beginners-shadow-box">
          <h2>Break the barriers to being fluent in English.</h2>
          <div className="beginners-promise-content">
            <div className="beginners-decorative-ring"></div>
            <p>
              At this Beginners level, you can
              <span className="beginners-highlight"></span> transform from being
              shy and hesitant to{" "}
              <span className="beginners-highlight">
                Confident and Expressive
              </span>
              . Step into a world where you communicate with clarity, poise, and
              natural fluency.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="beginners-benefits-section beginners-animate-on-scroll">
        <h2>WHAT YOU'LL ACHIEVE</h2>
        <div className="beginners-benefits-container">
          <div className="beginners-benefit-card">
            <img
              src={stick1}
              alt="Build Structure"
              className="beginners-benefit-image"
            />
            <h3>Speak Confidently</h3>
            <p>
              Master the art of introducing yourself and expressing basic
              thoughts without fear or hesitation
            </p>
          </div>
          <div className="beginners-benefit-card">
            <img
              src={stick2}
              alt="Build Structure"
              className="beginners-benefit-image"
            />
            <h3>Converse Naturally</h3>
            <p>
              Hold simple conversations and navigate day-to-day interactions
              with newfound confidence
            </p>
          </div>
          <div className="beginners-benefit-card">
            <img
              src={stick3}
              alt="Build Structure"
              className="beginners-benefit-image"
            />
            <h3>Build Structure</h3>
            <p>
              Develop a solid foundation of grammar and vocabulary that empowers
              your communication
            </p>
          </div>
        </div>
      </section>

      {/* Course Structure Section */}
       <section className="beginners-course-structure beginners-animate-on-scroll">
        <h2>YOUR 4-WEEK TRANSFORMATION</h2>
        <div className="beginners-timeline">
            {/*  Stick Figure */}
            <div className="stick-figure">
                <svg viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg">
                    {/*  Head */}
                    <circle cx="15" cy="6" r="4" stroke="#333" strokeWidth="2" fill="none"/>
                    {/*  Body */}
                    <line x1="15" y1="10" x2="15" y2="25" stroke="#333" strokeWidth="2"/>
                    {/*  Arms */}
                    <line x1="15" y1="15" x2="8" y2="20" stroke="#333" strokeWidth="2"/>
                    <line x1="15" y1="15" x2="22" y2="20" stroke="#333" strokeWidth="2"/>
                    {/*  Legs */}
                    <line x1="15" y1="25" x2="8" y2="35" stroke="#333" strokeWidth="2"/>
                    <line x1="15" y1="25" x2="22" y2="35" stroke="#333" strokeWidth="2"/>
                    {/*  Hands */}
                    <circle cx="8" cy="20" r="1.5" fill="#333"/>
                    <circle cx="22" cy="20" r="1.5" fill="#333"/>
                    {/*  Feet  */}
                    <circle cx="8" cy="35" r="1.5" fill="#333"/>
                    <circle cx="22" cy="35" r="1.5" fill="#333"/>
                </svg>
            </div>

            <div className="beginners-timeline-item">
                <div className="beginners-timeline-point"></div>
                <div className="beginners-timeline-content">
                    <h3>Week 1: Foundation Building</h3>
                    <p>
                        Break through initial barriers with introductions, basic
                        questions, and essential vocabulary
                    </p>
                </div>
            </div>
            <div className="beginners-timeline-item">
                <div className="beginners-timeline-point"></div>
                <div className="beginners-timeline-content">
                    <h3>Week 2: Practical Application</h3>
                    <p>
                        Engage in day-to-day role-play scenarios that build real-world
                        confidence
                    </p>
                </div>
            </div>
            <div className="beginners-timeline-item">
                <div className="beginners-timeline-point"></div>
                <div className="beginners-timeline-content">
                    <h3>Week 3: Fluency Development</h3>
                    <p>
                        Master the flow of conversation with enhanced vocabulary and
                        natural speech patterns
                    </p>
                </div>
            </div>
            <div className="beginners-timeline-item">
                <div className="beginners-timeline-point"></div>
                <div className="beginners-timeline-content">
                    <h3>Week 4: Confidence Mastery</h3>
                    <p>
                        Solidify your skills with comprehensive practice and receive
                        final certification
                    </p>
                </div>
            </div>
        </div>
    </section>

      {/* Course Components Section */}
      <section className="beginners-course-components beginners-animate-on-scroll">
        <h2>
          COMPREHENSIVE COURSE COMPONENTS
          
        </h2>

        {/* Floating background figures */}
       
        <div className="beginners-components-grid">
          <div className="beginners-component-card">
            <div className="beginners-component-number">01</div>
            <h3>Live Interactive Sessions</h3>
            <p>
              1-hour sessions with expert trainers who guide your speaking
              journey
            </p>
            <svg className="card-stick-figure" width="35" height="50" viewBox="0 0 35 50">
              <g className="stick-figure">
                <circle cx="17" cy="7" r="5" />
                <line x1="17" y1="12" x2="17" y2="30" />
                <line x1="17" y1="18" x2="10" y2="25" />
                <line x1="17" y1="18" x2="24" y2="25" />
                <line x1="17" y1="30" x2="10" y2="45" />
                <line x1="17" y1="30" x2="24" y2="45" />
                {/* Speaking bubble */}
                <circle cx="28" cy="12" r="4" strokeWidth="1" />
                <path d="M24 14 L22 16" strokeWidth="1" />
              </g>
            </svg>
          </div>

          <div className="beginners-component-card">
            <div className="beginners-component-number">02</div>
            <h3>Day-to-Day Role Play</h3>
            <p>
              Practice real-life scenarios that prepare you for authentic
              conversations
            </p>
            <svg className="card-stick-figure" width="50" height="50" viewBox="0 0 50 50">
              <g className="stick-figure">
                {/* Two figures role playing */}
                <circle cx="12" cy="7" r="4" />
                <line x1="12" y1="11" x2="12" y2="25" />
                <line x1="12" y1="16" x2="8" y2="20" />
                <line x1="12" y1="16" x2="16" y2="20" />
                <line x1="12" y1="25" x2="8" y2="35" />
                <line x1="12" y1="25" x2="16" y2="35" />
                
                <circle cx="35" cy="7" r="4" />
                <line x1="35" y1="11" x2="35" y2="25" />
                <line x1="35" y1="16" x2="31" y2="20" />
                <line x1="35" y1="16" x2="39" y2="20" />
                <line x1="35" y1="25" x2="31" y2="35" />
                <line x1="35" y1="25" x2="39" y2="35" />
                
                {/* Speech bubbles */}
                <ellipse cx="20" cy="12" rx="3" ry="2" strokeWidth="1" />
                <ellipse cx="27" cy="12" rx="3" ry="2" strokeWidth="1" />
              </g>
            </svg>
          </div>

          <div className="beginners-component-card">
            <div className="beginners-component-number">03</div>
            <h3>Structured Grammar Focus</h3>
            <p>
              Learn to speak with proper structure using practical grammar
              applications
            </p>
            <svg className="card-stick-figure" width="40" height="50" viewBox="0 0 40 50">
              <g className="stick-figure">
                <circle cx="20" cy="7" r="5" />
                <line x1="20" y1="12" x2="20" y2="30" />
                <line x1="20" y1="18" x2="12" y2="22" />
                <line x1="20" y1="18" x2="28" y2="22" />
                <line x1="20" y1="30" x2="15" y2="42" />
                <line x1="20" y1="30" x2="25" y2="42" />
                {/* Book/grammar symbol */}
                <rect x="26" y="15" width="8" height="6" strokeWidth="1" />
                <line x1="28" y1="17" x2="32" y2="17" strokeWidth="1" />
                <line x1="28" y1="19" x2="32" y2="19" strokeWidth="1" />
              </g>
            </svg>
          </div>

          <div className="beginners-component-card">
            <div className="beginners-component-number">04</div>
            <h3>Vocabulary Expansion</h3>
            <p>
              Build a rich vocabulary that empowers your everyday communication
            </p>
            <svg className="card-stick-figure" width="45" height="50" viewBox="0 0 45 50">
              <g className="stick-figure stick-figure-happy">
                <circle cx="20" cy="7" r="5" />
                <line x1="20" y1="12" x2="20" y2="30" />
                <line x1="20" y1="18" x2="14" y2="22" />
                <line x1="20" y1="18" x2="26" y2="22" />
                <line x1="20" y1="30" x2="15" y2="42" />
                <line x1="20" y1="30" x2="25" y2="42" />
                {/* Words floating around */}
                <text x="30" y="12" fontSize="4" fill="currentColor">ABC</text>
                <text x="32" y="25" fontSize="4" fill="currentColor">XYZ</text>
                <text x="8" y="20" fontSize="4" fill="currentColor">123</text>
              </g>
            </svg>
          </div>

          <div className="beginners-component-card">
            <div className="beginners-component-number">05</div>
            <h3>Daily Practice Sessions</h3>
            <p>
              Reinforce learning with consistent, guided practice opportunities
            </p>
            <svg className="card-stick-figure" width="40" height="50" viewBox="0 0 40 50">
              <g className="stick-figure">
                <circle cx="18" cy="7" r="5" />
                <line x1="18" y1="12" x2="18" y2="30" />
                <line x1="18" y1="18" x2="12" y2="24" />
                <line x1="18" y1="18" x2="24" y2="24" />
                <line x1="18" y1="30" x2="13" y2="42" />
                <line x1="18" y1="30" x2="23" y2="42" />
                {/* Calendar/clock symbol */}
                <rect x="26" y="12" width="8" height="8" strokeWidth="1" />
                <line x1="28" y1="14" x2="32" y2="14" strokeWidth="1" />
                <line x1="30" y1="16" x2="30" y2="18" strokeWidth="1" />
              </g>
            </svg>
          </div>

          <div className="beginners-component-card">
            <div className="beginners-component-number">06</div>
            <h3>Weekly Feedback Reports</h3>
            <p>
              Track your progress with personalized insights and improvement
              plans
            </p>
            <svg className="card-stick-figure" width="45" height="50" viewBox="0 0 45 50">
              <g className="stick-figure stick-figure-excited">
                <circle cx="18" cy="7" r="5" />
                <line x1="18" y1="12" x2="18" y2="30" />
                <line x1="18" y1="18" x2="12" y2="15" />
                <line x1="18" y1="18" x2="24" y2="15" />
                <line x1="18" y1="30" x2="13" y2="42" />
                <line x1="18" y1="30" x2="23" y2="42" />
                {/* Chart/graph symbol */}
                <line x1="28" y1="25" x2="40" y2="25" strokeWidth="1" />
                <line x1="28" y1="12" x2="28" y2="25" strokeWidth="1" />
                <polyline points="28,22 32,18 36,20 40,15" strokeWidth="1" fill="none" />
                {/* Happy face */}
                <circle cx="15" cy="5" r="0.5" fill="currentColor" />
                <circle cx="21" cy="5" r="0.5" fill="currentColor" />
                <path d="M14 9 Q18 11 22 9" strokeWidth="1" />
              </g>
            </svg>
          </div>
        </div>
      </section>

      {/* Trainers Section */}
      <section className="beginners-trainers-section beginners-animate-on-scroll">
        <h2>LEARN FROM THE BEST</h2>
        <div className="beginners-shadow-box beginners-trainer-box">
          <div className="beginners-decorative-circle beginners-trainer-circle"></div>
          <h3>EXPERT TRAINERS WHO TRANSFORM LIVES</h3>
          <ul className="beginners-trainer-features">
            <li>
              <span>Certified IELTS and TOEFL Trainers</span>
            </li>
            <li>
              <span>Advanced credentials in Business Communication</span>
            </li>
            <li>
              <span>International teaching experience</span>
            </li>
            <li>
              <span>Specialized in confidence-building techniques</span>
            </li>
          </ul>
          <p>
            Our trainers don't just teach English—they empower you to find your
            voice and express yourself boldly.
          </p>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="beginners-what-you-get-section beginners-animate-on-scroll">
        <h2>EVERYTHING YOU RECEIVE</h2>
        <div className="beginners-features-container">
          <div className="beginners-feature-item">
            <div className="beginners-feature-icon beginners-check-icon"></div>
            <p>30 days of transformative training</p>
          </div>
          <div className="beginners-feature-item">
            <div className="beginners-feature-icon beginners-check-icon"></div>
            <p>Live sessions with experienced trainers</p>
          </div>

          <div className="beginners-feature-item">
            <div className="beginners-feature-icon beginners-check-icon"></div>
            <p>Printable practice materials</p>
          </div>
          <div className="beginners-feature-item">
            <div className="beginners-feature-icon beginners-check-icon"></div>
            <p>Weekly progress reports</p>
          </div>
          <div className="beginners-feature-item">
            <div className="beginners-feature-icon beginners-check-icon"></div>
            <p>Certificate of completion</p>
          </div>
          <div className="beginners-feature-item">
            <div className="beginners-feature-icon beginners-check-icon"></div>
            <p>Access to practice community</p>
          </div>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="beginners-transformation-section beginners-animate-on-scroll">
        <h2>YOUR TRANSFORMATION JOURNEY</h2>
        <div className="beginners-before-after-container">
          <div className="beginners-before-box">
            <h3>BEFORE</h3>
            <ul>
              <li>Hesitant to speak in public</li>
              <li>Struggling with basic conversations</li>
              <li>Limited vocabulary</li>
              <li>Lack of confidence in English</li>
              <li>Missing opportunities due to language barriers</li>
            </ul>
          </div>
          <div className="beginners-arrow-transform">
            <div className="beginners-arrow-body"></div>
            <div className="beginners-arrow-head"></div>
          </div>
          <div className="beginners-after-box">
            <h3>AFTER</h3>
            <ul>
              <li>Confidently introducing yourself</li>
              <li>Engaging in everyday conversations</li>
              <li>Expanded practical vocabulary</li>
              <li>Speaking with proper structure</li>
              <li>Newfound confidence that opens doors</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <PopupForm isOpen={showForm} onClose={handleCloseForm} />
      {/* Final CTA Section */}
    </div>
  );
};

export default BeginnersCoursePage;